import React, { useEffect } from 'react'
import "./ScrollToTop.css"
import whatsappIco from '../../assets/projectsInfo/whatsapp-logo-11.png'

function ScrollToTop() {
    useEffect(() => {
        const handleScroll = () => {
            const scrollUp = document.querySelector(".scrollup")
            if (window.scrollY >= 800) scrollUp.classList.add("show-scroll")
            else scrollUp.classList.remove("show-scroll")
        }
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

  return (
      <a href="/" className="scrollup">
          <a target="_blank" rel='noreferrer' href='https://api.whatsapp.com/send?phone=+34641415001&text=Hola,%20te%20queremos%20contactar'>
            <img src={whatsappIco} alt="logo de whatsapp" />
          </a>
      </a>
    )
}

export default ScrollToTop